import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';

interface ScanResult {
  decodedText: string;
  timestamp: Date;
  format: string;
}

const BarCodes: React.FC = () => {
  const html5QrcodeRef = useRef<Html5Qrcode | null>(null);
  const [scanResults, setScanResults] = useState<ScanResult[]>([]);
  const [error, setError] = useState<string>('');
  const [cameraStarted, setCameraStarted] = useState<boolean>(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        html5QrcodeRef.current = new Html5Qrcode('qr-reader');
        const cameras = await Html5Qrcode.getCameras();
        if (!mounted) return;
        if (cameras && cameras.length > 0) {
          const backCamera = cameras.find(device =>
            /back|rear|environment/i.test(device.label)
          );
          const cameraId = backCamera ? backCamera.id : cameras[0].id;
          await html5QrcodeRef.current.start(
            cameraId,
            {
              fps: 10,
              qrbox: { width: 300, height: 300 },
              disableFlip: false
            },
            (decodedText, decodedResult) => {
              const format = decodedResult.result?.format?.formatName || '';
              if (format === 'EAN_13' || format === 'EAN-13') return;
              setScanResults(prev => {
                if (prev[0]?.decodedText === decodedText) return prev;
                return [{ decodedText, timestamp: new Date(), format }, ...prev.slice(0, 9)];
              });
            },
            () => {}
          );
          setCameraStarted(true);
          setError('');
        } else {
          setError('Камеры не найдены');
        }
      } catch (err: any) {
        setError('Не удалось запустить камеру. ' + (err.message || 'Проверьте разрешения.'));
      }
    })();
    return () => {
      mounted = false;
      if (html5QrcodeRef.current) {
        html5QrcodeRef.current.stop().catch(() => {});
        html5QrcodeRef.current = null;
      }
    };
  }, []);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
      .then(() => alert('Скопировано'))
      .catch(() => alert('Ошибка копирования'));
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 20 }}>
      <div id="qr-reader"
        style={{
          width: 320, height: 320,
          margin: "0 auto",
          border: '2px solid #dee2e6',
          borderRadius: 10,
          overflow: 'hidden',
          background: cameraStarted ? undefined : '#eee'
        }}
      />
      {error && (
        <div style={{
          background: '#f8d7da', color: '#721c24',
          padding: 12, borderRadius: 6,
          marginTop: 12, marginBottom: 12
        }}>
          {error}
        </div>
      )}
      <div style={{ marginTop: 24 }}>
        <h3>Результаты сканирования: {scanResults.length}</h3>
        {scanResults.length === 0 && (
          <div style={{
            background: '#f6f8fa', color: '#666',
            padding: 10, borderRadius: 5
          }}>Отсканированные коды появятся здесь</div>
        )}
        {scanResults.length > 0 && (
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {scanResults.map((result, idx) => (
              <div key={idx} style={{
                border: '1px solid #eee', borderRadius: 8,
                padding: 10, marginBottom: 10, background: '#fff'
              }}>
                <div style={{ color: "#888", fontSize: 13 }}>
                  {result.timestamp.toLocaleString()} <b style={{
                  color:
                    result.format === "DATA_MATRIX"
                      ? "#9c27b0"
                      : "#007bff"
                  }}>{result.format}</b>
                </div>
                <div style={{
                  fontFamily: "monospace", fontSize: 14,
                  margin: "8px 0"
                }}>{result.decodedText}</div>
                <button
                  onClick={() => copyToClipboard(result.decodedText)}
                  style={{
                    background: '#17a2b8', color: 'white',
                    border: 'none', padding: '4px 10px', borderRadius: 4,
                    cursor: 'pointer', fontSize: 13
                  }}>📋 Копировать
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BarCodes;
